<!--
    知识点错误率横向柱状统计图公共组件
-->
<template>
            <el-row class="content_detail">
                <el-col class="resource-type">
                        <div v-show="knowRateShow" :id="id" class="knowledgeBox upload-width"></div>
                        <p v-show="!knowRateShow" class="emptyBox">
                            <i class="nucfont inuc-empty-file"></i>
                            {{$t('c.noData')}}</p>
                </el-col>
            </el-row>
</template>

<script>

    var echarts = require('echarts');
    export default {
        props: ['statisticName', 'id', 'sourceType', 'legendName'],
        data() {
            return {
                knowRateShow: false,
                uploadId: this.id
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            knowRateOption(data, id) {
                let knowRateChart = echarts.init(document.getElementById(id));
                knowRateChart.showLoading();
                let obj = {};
                obj.name = this.legendName ? this.legendName : this.$t('count.wrongRate');
                obj.nameData = [];
                obj.nameData.push(obj.name);
                obj.xAxisData= []
                obj.seriesData = [];
                if (data) {
                    if (data.length > 0) {
                        this.knowRateShow = true;
                        data.forEach((elem, index) => {
                            // obj.xAxisData.push(elem.name);
                            obj.xAxisData[index] = elem.name;
                            obj.seriesData.push(Math.round(elem.value * 10000) / 100);
                        });
                        //制定图标的配置项和数据
                        let option = {
                            tooltip: {
                                trigger: 'axis',
                                formatter: function (params) {
                                    var relVal = params[0].name;
                                    for (var i = 0, l = params.length; i < l; i++) {
                                        relVal += '<br/>' + params[i].seriesName + ' : ' + params[i].value + "%";
                                    }
                                    return relVal;
                                },
                            },
                            legend: {
                                data: obj.nameData
                            },
                            grid: {
                                left: '3%',
                                right: '4%',
                                bottom: '3%',
                                containLabel: true
                            },
                            xAxis: [
                                {
                                    type: 'value',
                                    boundaryGap : [0, 0.01],
                                    axisLabel : {
                                        formatter: '{value}%'
                                    },
                                    min:0,
                                    max:100
                                }
                            ],
                            yAxis: {
                                type : 'category',
                                data: obj.xAxisData,
                            },

                            series: [{
                                name: obj.name,
                                type: 'bar',
                                barMaxWidth: 30,
                                data: obj.seriesData,
                                itemStyle: {
                                    normal: {
                                        color: new echarts.graphic.LinearGradient(
                                            0, 0, 1, 0,
                                            [
                                                {offset: 0, color: '#5da4ba'},
                                                {offset: 1, color: '#228bb4'}
                                            ]
                                        )
                                    }
                                }
                            }]
                        };
                        knowRateChart.hideLoading();
                        knowRateChart.setOption(option);
                    } else {
                        knowRateChart.hideLoading();
                        this.knowRateShow = false;
                    }
                } else {
                    knowRateChart.hideLoading();
                    this.knowRateShow = false;
                }
            },
        },
        name: "StatisticsKnowledgeRate"
    }
</script>

<style scoped lang="scss">
    @import '../../style/const';

    .toolDiv {
        height: auto;
    }

    .content_detail {
        padding: 20px;
        display: flex;
        .resource-type {
            flex: 1;
            margin: 0 5px;
            .knowledgeBox {
                width: 450px;
                min-width: 350px;
                height: 320px;
                margin: auto;
            }
            .emptyBox {
                text-align: center;
                height: 320px;
                line-height: 320px;
                margin: auto;
            }
        }
    }
</style>
